export var DesiredFeatures;
(function (DesiredFeatures) {
    DesiredFeatures["FixedRate"] = "FIXED_RATE";
    DesiredFeatures["MobileApp"] = "MOBILE_APP";
    DesiredFeatures["MajorLender"] = "MAJOR_LENDER";
    DesiredFeatures["OffsetRedraw"] = "OFFSET_OR_REDRAW";
    DesiredFeatures["Offset"] = "OFFSET";
    DesiredFeatures["Redraw"] = "REDRAW";
})(DesiredFeatures || (DesiredFeatures = {}));
//# sourceMappingURL=index.js.map